import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

// CONSTANTS
import { SANTAS_GRAY } from '@/constants/colors';

export const getCardStyle = ({ palette: { text, error } }) => ({
  base: {
    iconColor: text.secondary,
    fontSize: '16px',
    ':-webkit-autofill': { color: text.secondary },
    '::placeholder': { color: text.secondary },
  },
  invalid: {
    iconColor: error.main,
  },
});

export const CardFieldsStyled = styled.fieldset`
  padding: 0;
  border-style: none;

  .MuiFormHelperText-root {
    margin-right: 0;
  }

  .cvc-wrapper {
    width: 100%;
    min-width: 150px;

    display: flex;
    align-items: flex-start;

    .MuiFormHelperText-root {
      width: 150px;
    }
  }
`;

export const SCVCTooltip = styled(Tooltip)``;

export const SInfoIconButton = styled(IconButton)`
  padding: 10px;
  color: ${SANTAS_GRAY};
`;

export default CardFieldsStyled;
